import React, { Component } from "react";
import PropTypes from "prop-types";
import { Loader } from "~/components";
import styles from "./ShareBooking.scss";
import { createSharedBooking } from "../../utils/witbookingApi";
import { getFromSessionStorage } from "../../utils/misc";
import { defineMessages, FormattedMessage } from "react-intl";
import constants from "../../utils/constants";
import Clipboard from "clipboard";

const msgs = defineMessages({
  shareBookingCart: {
    id: "app.share_booking.share_booking_cart",
    description: "Share booking cart",
    defaultMessage: "Share booking cart",
  },
  description: {
    id: "app.share_booking.description",
    description: "Description of service",
    defaultMessage: "Use this link to share your booking cart (bookings, extras services)",
  },
  copyLink: {
    id: "app.share_booking.copyLink",
    description: "copyLink",
    defaultMessage: "copy link",
  },
});

class ShareBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
    this.shareBooking = this.shareBooking.bind(this);
  }

  componentDidMount() {
    this.shareBooking(this.props);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.locale !== this.props.locale ||
      prevProps.propertyTicker !== this.props.propertyTicker
    ) {
      this.shareBooking(this.props);
    }
  }

  componentWillUnmount() {
    this.setState({ error: null, shareURL: null, isLoading: false });
  }

  initClipboard(button) {
    if (button) {
      const clipboard = new Clipboard(button); //eslint-disable-line
    }
  }

  shareBooking(props) {
    const cart = getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.CART);
    try {
      if (!cart) {
        throw new Error("empty cart");
      }
      createSharedBooking(
        {},
        {
          cart,
          locale: props.locale,
          propertyTicker: props.propertyTicker,
          urlParams: {
            affiliate: props.affiliate,
            origin: props.origin,
            mode: props.mode,
          },
        }
      )
        .then(response => {
          if (!response || !response.hasOwnProperty("resource")) {
            throw new Error("error");
          }
          const key = response.resource.split("/").pop();
          const shareURL = `${window.location.protocol}//${window.location.host}/${props.propertyTicker}/checkout?session=${key}&isSharedBooking=1`;
          this.setState({ shareURL, isLoading: false });
        })
        .catch(err => {
          this.handleError(err);
        });
    } catch (error) {
      console.error(error);
      this.handleError(error);
    }
  }

  handleError(error) {
    this.setState({ error, isLoading: false });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className={styles.container}>
          <Loader />
        </div>
      );
    }

    if (this.state.error) {
      return <div className={styles.container}>Could not share cart</div>;
    }

    return (
      <div className={styles.container}>
        <div className={styles.description}>
          <FormattedMessage {...msgs.description} />:
        </div>

        <div className={styles.shareUrl}>
          <span>{this.state.shareURL}</span>
        </div>

        <div
          className={styles.copyButton}
          data-clipboard-text={this.state.shareURL}
          ref={button => this.initClipboard(button)}>
          <FormattedMessage {...msgs.copyLink} />
        </div>
      </div>
    );
  }
}

ShareBooking.propTypes = {
  propertyTicker: PropTypes.string,
  locale: PropTypes.string,
};

export default ShareBooking;
